<template>
  <div class="container mt-5">
    <div class="form-wrapper mx-auto" style="max-width: 500px;">
      <h2 class="mb-4 text-center">Editar Perfil</h2>
      <form @submit.prevent="editarPerfil">
        <div class="mb-3">
          <label for="username" class="form-label">Nombre de Usuario</label>
          <input type="text" id="username" v-model="username" class="form-control" required />
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Correo Electrónico</label>
          <input type="email" id="email" v-model="email" class="form-control" required />
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Nueva Contraseña</label>
          <input type="password" id="password" v-model="password" class="form-control" />
        </div>
        <div class="mb-3">
          <label for="confirmPassword" class="form-label">Confirmar Nueva Contraseña</label>
          <input type="password" id="confirmPassword" v-model="confirmPassword" class="form-control" />
        </div>
        <button type="submit" class="btn btn-primary w-100">Guardar Cambios</button>
      </form>
    </div>
  </div>
</template>




<script setup>
import { ref, onMounted,defineEmits } from 'vue'
import axios from '@/axios'

const emit = defineEmits(['volver'])

const username = ref('')
const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const user_id = ref(null)

onMounted(async () => {
  try {
    const response = await axios.get('/api/usuarios/me', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    username.value = response.data.nombre
    email.value = response.data.email
    user_id.value = response.data.id
  } catch (error) {
    console.error('Error al obtener los datos del usuario:', error)
  }
})

const editarPerfil = async () => {
  if (password.value !== confirmPassword.value) {
    alert('Las contraseñas no coinciden. Por favor, inténtalo de nuevo.')
    return
  }
  try {
    await axios.put('/api/usuarios/me', {
      nombre: username.value,
      email: email.value,
      password: password.value,
      user_id: user_id.value,
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    alert('Perfil actualizado con éxito.')
    emit('volver') // ✅ navegación interna
  } catch (error) {
    alert('Error al actualizar el perfil.')
  }
}
</script>



  <style scoped>
    .container {
      margin-top: 40px;
    }

    .form-wrapper {
      background-color: #f8f9fa; /* Fondo más suave para diferenciarlo del fondo general */
      padding: 20px;
      border-radius: 5px;
      box-shadow: none; /* Eliminamos la sombra para evitar que sobresalga */
    }
</style>
